import { defineStore } from "pinia";

import {
  ACTION_REPORT_MODAL_SET,
  ACTION_REPORT_CANDIDATE_SET,
  ACTION_REPORT_DEMAND_SET,
  GETTER_REPORT_CANDIDATE_ID_GET,
  GETTER_REPORT_CANDIDATE_FIRSTNAME_GET,
  GETTER_REPORT_MODAL_GET,
  GETTER_REPORT_DEMAND_GET,
} from "@etab/stores/types";

export const useReportCandidateStore = defineStore("reportCandidate", {
  // convert to a function
  state: () => ({
    openModal: false,
    candidateId: null,
    candidateFirstname: "",
    demandId: null,
  }),
  getters: {
    [GETTER_REPORT_DEMAND_GET]: (state) => state.demandId,
    [GETTER_REPORT_MODAL_GET]: (state) => state.openModal,
    [GETTER_REPORT_CANDIDATE_ID_GET]: (state) => state.candidateId,
    [GETTER_REPORT_CANDIDATE_FIRSTNAME_GET]: (state) => state.candidateFirstname,
  },
  actions: {
    [ACTION_REPORT_DEMAND_SET](demandId) {
      this.demandId = demandId;
    },
    [ACTION_REPORT_MODAL_SET](openModal) {
      this.openModal = openModal;
    },
    [ACTION_REPORT_CANDIDATE_SET]({ candidateId, candidateFirstname }) {
      this.candidateId = candidateId;
      this.candidateFirstname = candidateFirstname;
    },
    // easily reset state using `$reset`
    clearReportCandidateStore() {
      this.$reset();
    },
  },
});
